import { FileWithPath } from "@mantine/dropzone"
import { useMutation, UseMutationOptions } from "@tanstack/react-query"
import { AxiosError } from "axios"

import { httpClient } from "~/backend/axios"

type ErrorContent = {
  [errorType: string]: string
}

export type ErrorLogs = {
  title: string
  content: ErrorContent
}

type ProductImportVerifyRequest = {
  file: FileWithPath
  clientUserEmail: string
}

export const useVerifyProductImportMutation = (
  options?: UseMutationOptions<
    number,
    AxiosError<ErrorLogs>,
    ProductImportVerifyRequest
  >
) =>
  useMutation(
    async ({ file, clientUserEmail }: ProductImportVerifyRequest) => {
      const formData = new FormData()
      formData.set("file", file)
      formData.set("clientUserEmail", clientUserEmail)

      const response = await httpClient.post(
        "/v1/product/verify-import",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      )

      return response.data
    },
    {
      ...options,
    }
  )
